import axios from 'axios'
import { ENDPOINTS } from '@/config/endpoints'

// Trigger BlueShift event
export async function triggerEvent(email, eventName) {
  const url = `${ENDPOINTS.BLUESHIFT_EVENTS}?email=${encodeURIComponent(email)}&eventName=${eventName}`

  try {
    const response = await axios.post(url)
    console.log(`BlueShift ${eventName} response:`, response.data)
    return response.data
  } catch (error) {
    console.error(`BlueShift ${eventName} error:`, error)
    return null
  }
}

// Trigger fafSignup event (after email submission)
export async function triggerFafSignup(email) {
  return triggerEvent(email, 'fafSignup')
}

// Trigger fullsubmit event (after phone submission)
export async function triggerFullSubmit(email) {
  return triggerEvent(email, 'fullsubmit')
}

// Trigger buyer sequence event (after successful lead)
export async function triggerBuyerSequence(email) {
  return triggerEvent(email, 'triggerBuyerSequence')
}

export const blueShiftService = {
  triggerEvent,
  triggerFafSignup,
  triggerFullSubmit,
  triggerBuyerSequence
}
